export const METRIC_COLUMN_IDS = {
  messagesPerStream: "messages_per_stream",
  associatedStreams: "associated_streams",
  failureCount: "failure_count"
};
export const METRIC_COLUMN_TITLES = {
  [METRIC_COLUMN_IDS.messagesPerStream]: "Message Count (Last 24H)",
  [METRIC_COLUMN_IDS.associatedStreams]: "Associated Streams (Last 24H)",
  [METRIC_COLUMN_IDS.failureCount]: "Failure Count (Last 15min)"
};
const REQUIRED_BACKEND_FIELDS = {
  [METRIC_COLUMN_IDS.messagesPerStream]: ["messages_per_stream"],
  [METRIC_COLUMN_IDS.associatedStreams]: ["messages_per_stream"],
  [METRIC_COLUMN_IDS.failureCount]: ["failure_count"]
};
export const backendFieldsForVisibleColumns = (visibleColumnIds) => {
  const fields = /* @__PURE__ */ new Set();
  for (const id of visibleColumnIds) {
    const required = REQUIRED_BACKEND_FIELDS[id];
    if (required) {
      required.forEach((f) => fields.add(f));
    }
  }
  return Array.from(fields);
};
